import { createSelector } from 'reselect';
import isEmpty from 'lodash/isEmpty';
import shuffle from 'lodash/shuffle';
import config from '../configs';

const { api: { contentParams } } = config;

const collectLoadState = (stickyFooter, flag) => (
  contentParams.map(({ content_group_id }) => (
    { [content_group_id]: !!stickyFooter[content_group_id]?.[flag] }
  ))
);

export const selectStickyFooter = state => state.stickyFooter;
export const selectStickyFooterConfig = createSelector(selectStickyFooter, stickyFooter => stickyFooter.config);

export const selectStickyFooterIsLoading = createSelector(selectStickyFooter, stickyFooter => (
  collectLoadState(stickyFooter, 'isLoading')
));

export const selectStickyFooterIsLoaded = createSelector(selectStickyFooter, stickyFooter => (
  collectLoadState(stickyFooter, 'isLoaded')
));

export const selectStickyFooterAllDataIsLoaded = createSelector(selectStickyFooter, stickyFooter => (
  contentParams.every(({ content_group_id }) => (
    stickyFooter?.[content_group_id]?.isLoaded
  ))
));

export const selectStickyFooterPlacement = createSelector(
  [selectStickyFooter, selectStickyFooterAllDataIsLoaded],
  (stickyFooter, stickyFooterAllDataIsLoaded) => {
    if (!stickyFooterAllDataIsLoaded) return {};

    const placements = contentParams
      .map(({ content_group_id }) => stickyFooter[content_group_id].placement)
      .filter(item => !isEmpty(item));

    return shuffle(placements)[0];
  },
);
